import React from 'react';

import './styles.scss';

const Radio = ({ name, id, label, labelPosition = "left", ...rest }) => {


  return (
    <label htmlFor={id} className="paylixecommerce-radio-container paylixecommerce-label">
      {labelPosition === 'left' ? label : null}
      <input type="radio" id={id} name={name} {...rest} />
      <span className="paylixecommerce-radio-checkmark"></span>
      {labelPosition === 'right' ? label : null}
    </label>
  );
}

export default Radio;
